<template>
  <div>
    <el-button type="text"
               @click="preview">预览</el-button>
    <el-button type="text"
               @click="addCustom">添加</el-button>
  </div>
</template>

<script>
import { getCopyCustom } from '@/api/inspiration'
const homeMapTest = {
  fenxiplus: 'fenxitest.mktindex.com',
  comment: 'commenttest.mktindex.com',
  sociales: 'socialtest.mktindex.com',
  oversea: 'overseanew.mktindex.com',
}
const homeMapProd = {
  fenxiplus: 'fenxiplus.mktindex.com',
  comment: 'comment.mktindex.com',
  sociales: 'social.mktindex.com',
  oversea: 'oversea.mktindex.com',
}
const linkMapTest = {
  fenxiplus: 'https://fenxitest.mktindex.com/#/detail?',
  comment: 'https://commenttest.mktindex.com/#/catsheetnew?',
  sociales: 'https://socialtest.mktindex.com/#/customManage',
  oversea: 'https://overseanew.mktindex.com/#/detail?',
}
const linkMapProd = {
  fenxiplus: 'https://fenxiplus.mktindex.com/#/detail?',
  comment: 'https://comment.mktindex.com/#/catsheetnew?',
  sociales: 'https://social.mktindex.com/#/customManage',
  oversea: 'https://oversea.mktindex.com/#/detail?',
}
export default {
  props: ['value', 'field', 'xprops'],
  data() {
    return {}
  },
  computed: {},
  methods: {
    preview(item) {
      const params = {
        previewDialog: true,
        priviewData: this.value,
      }
      this.xprops.eventbus.$emit('NAME_CLICK', params)
    },
    addCustom(item) {
      const params = {
        home: this.$attrs.row.home, // 域名
        publish_user: this.$attrs.row.publish_user, // 发布者
        rule_id: this.$attrs.row.rule_id,
      }
      getCopyCustom(params)
        .then((res) => {
          const { product } = this.$attrs.row
          const host = window.location.host
          const isPartner = this.$store.state.user.loginInfo.is_partner
          if (
            res.result.data &&
            res.result.status == 'ok' &&
            product == 'sociales'
          ) {
            let home
            let link
            if (host == 'cmi.mktindex.com') {
              home = homeMapProd['sociales']
              link = linkMapProd['sociales']
            } else {
              home = homeMapTest['sociales']
              link = linkMapTest['sociales']
            }
            if (isPartner) {
              this.$alert('', '添加成功！', {
                confirmButtonText: '继续添加',
                confirmButtonClass: 'msgBtn',
              })
            } else {
              const linkText = `立刻前往产品查看→ <a href="${link}" target="_blank">${home}</a>`
              this.$alert(linkText, '添加成功！', {
                confirmButtonText: '继续添加',
                confirmButtonClass: 'msgBtn',
                dangerouslyUseHTMLString: true,
              })
            }
          } else if (
            res.result.data &&
            res.result.status == 'ok' &&
            product == 'comment'
          ) {
            const { data } = res.result
            let home
            let link
            if (host == 'cmi.mktindex.com') {
              home = homeMapProd['comment']
              link =
                linkMapProd['comment'] +
                `plat=${data.plat}&cid=${data.cid}&start=${data.start}&end=${data.end}`
            } else {
              home = homeMapTest['comment']
              link =
                linkMapTest['comment'] +
                `plat=${data.plat}&cid=${data.cid}&start=${data.start}&end=${data.end}`
            }
            if (isPartner) {
              this.$alert('', '添加成功！', {
                confirmButtonText: '继续添加',
                confirmButtonClass: 'msgBtn',
              })
            } else {
              const linkText = `立刻前往产品查看→ <a href="${link}" target="_blank">${home}</a>`
              this.$alert(linkText, '添加成功！', {
                confirmButtonText: '继续添加',
                confirmButtonClass: 'msgBtn',
                dangerouslyUseHTMLString: true,
              })
            }
          } else if (res.status == 'ok') {
            const { product } = this.$attrs.row
            const host = window.location.host
            const { url_id, time } = res.result
            let home
            let link
            if (host == 'cmi.mktindex.com') {
              home = homeMapProd[product]
              link =
                linkMapProd[product] +
                `url_id=${url_id.url_id}&start=${time[0]}&end=${time[1]}`
            } else {
              home = homeMapTest[product]
              link =
                linkMapTest[product] +
                `url_id=${url_id.url_id}&start=${time[0]}&end=${time[1]}`
            }
            if (isPartner) {
              this.$alert('', '添加成功！', {
                confirmButtonText: '继续添加',
                confirmButtonClass: 'msgBtn',
              })
            } else {
              const linkText = `立刻前往产品查看→ <a href="${link}" target="_blank">${home}</a>`
              this.$alert(linkText, '添加成功！', {
                confirmButtonText: '继续添加',
                confirmButtonClass: 'msgBtn',
                dangerouslyUseHTMLString: true,
              })
            }
          }
        })
        .catch((e) => {
          const message =
            '添加失败！您没有相关产品/类目权限，请联系客户经理开通~'
          this.$alert(message, '', {
            confirmButtonText: '我知道了',
            confirmButtonClass: 'msgBtn',
          })
        })
    },
  },
}
</script>

<style lang="less" scoped>
</style>
